export class MeterReadingInsert {
    constructor(
        public clientCode: string,
        public fullName: string,
        public installationNumber: string,
        public interlocutorId: string,
        public value: number,
        public base64Image: string,
        public channel: string,
        public documentNumber: string,
        public token: string
    ) { }
}

export class MeterReadingDownloadPdf {
    constructor(
        public operationNumber: string,
        public imageBase64: string,
        public nextDate: string
    ) { }
}